import { mapGetters, mapActions } from 'vuex'
import { store } from '_/vuex/store'
import Vue from 'vue'
const photonConfig = require('~/config/config.json')
const MassEditor = Vue.component(
  'MassEditor',
  require('_/components/Admin/MassEditor/MassEditor.vue').default
)

export default {
  /*
   * Define props
   *
   * @type  {Object}
   */
  props: {
    moduleTableName: {
      type: String,
      default: null,
    },
    relatedTableNames: {
      type: Array,
      default: () => [],
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    viewSelectionMode: {
      type: Boolean,
      default: false,
    },
    vuexModuleName: {
      type: String,
      default: 'advancedSearch',
    },
    selectedEntries: {
      type: Array,
      default: () => [],
    },
  },

  data: function() {
    return {
      fields: [],
      serverError: null,
    }
  },

  /**
   * Define components
   *
   * @type  {Object}
   */
  components: {
    MassEditor,
  },

  computed: {
    ...mapGetters({
      admin: 'admin/admin',
      ui: 'ui/ui',
    }),

    /**
     * Advanced Search module getter
     *
     * @return  {object}
     */
    advancedSearch() {
      const getterName = `${this.vuexModuleName}/${this.vuexModuleName}`
      return store.getters[getterName]
    },

    /**
     * Returns the photonConfig object
     *
     * @return  {object}
     */
    photonConfig() {
      return photonConfig
    },

    trimmedPagination() {
      let pages = []

      const currentPage = this.pagination.current_page

      const totalPages = this.pagination.last_page

      for (
        let page = Math.max(1, currentPage - 3);
        page <= Math.min(currentPage + 3, totalPages);
        page++
      ) {
        pages.push(page)
      }

      return pages
    },

    /**
     * Date format getter
     *
     * @return  {string}
     */
    dateFormat() {
      return this.ui.photonConfig.dateFormat
    },

    selectedModule() {
      if (this.moduleTableName) {
        return this.moduleTableName
      }

      return this.admin.selectedModule.table_name
    },

    results() {
      if (this.viewSelectionMode) {
        return this.selectedEntries
      }

      return this.advancedSearch.entries
    },

    pagination() {
      return this.advancedSearch.entriesPagination
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    downloadFile(payload) {
      return store.dispatch(`${this.vuexModuleName}/downloadFile`, payload)
    },

    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    hideMassEditor(payload) {
      return store.dispatch(`${this.vuexModuleName}/hideMassEditor`, payload)
    },

    /**
     * Returns true if an entry is selected
     *
     * @return  {Object}
     */
    isSelectedEntry(entry) {
      const entryId = _.get(entry, 'system.id')
      const entryTableName = _.get(entry, 'system.module.table_name')
      return _.find(this.selectedEntries, entry => {
        return (
          entry.system.id === entryId &&
          entry.system.module.table_name === entryTableName
        )
      })
    },

    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    navigateToEntry(payload) {
      return store.dispatch(`${this.vuexModuleName}/navigateToEntry`, payload)
    },

    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    navigateToPage(payload) {
      return store.dispatch(`${this.vuexModuleName}/navigateToPage`, payload)
    },

    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    showMassEditor(payload) {
      return store.dispatch(`${this.vuexModuleName}/showMassEditor`, payload)
    },

    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    filterModuleEntries(payload) {
      return store.dispatch(
        `${this.vuexModuleName}/filterModuleEntries`,
        payload
      )
    },

    /**
     * Maps the appropriate action
     *
     * @param   {object}  payload
     * @return  {promise}
     */
    updateSorting(payload) {
      return store.dispatch(`${this.vuexModuleName}/updateSorting`, payload)
    },

    /**
     * Emits a select entry action
     *
     * @param   {object}  entry
     * @return  {void}
     */
    selectEntry(entry, openInNewTab = false) {
      this.$emit('selectEntry', { entry, openInNewTab })
    },

    /**
     * Toggles the sorting direction.
     *
     * @param {string} name
     */
    toggleSortingDirection(name) {
      this.updateSorting({ name })
      const payload = this.advancedSearch.payload
      this.filterModuleEntries({
        moduleTableName:
          this.relatedTableNames.length > 1
            ? this.relatedTableNames
            : this.moduleTableName,
        payload,
      })
    },

    /**
     * Created at getter
     *
     * @param   {integer}  entry
     * @return  {string}
     */
    createdAt(entry) {
      return entry.system.created_at
        ? moment(entry.system.created_at).format(this.dateFormat)
        : null
    },

    /**
     * Navigates to a different result page
     *
     * @param   {integer}  value
     * @return  {void}
     */
    goToPage(value) {
      this.navigateToPage({
        value,
        tableName:
          this.relatedTableNames.length > 1
            ? this.relatedTableNames
            : this.moduleTableName,
      }).then(() => {
        $(this.$el)
          .find('.pagination li a')
          .blur()
      })
    },

    /**
     * Updated at getter
     *
     * @param   {integer}  entry
     * @return  {string}
     */
    updatedAt(entry) {
      return entry.system.updated_at
        ? moment(entry.system.updated_at).format(this.dateFormat)
        : null
    },
  },
}
